import DS from 'ember-data';

import CIOJSONAPICache from 'cio/store/cache';

// We import this file in store.js, to avoid namespace collisions
// between our .ts service definitions and .js definitions from services from
// addons.
// This is to avoid the following warning:
//
// WARNING: Detected collisions between .js and .ts files of the same name.
// This can result in nondeterministic build output; see https://git.io/JvIwo for more information.
//
export default class CustomStore extends DS.Store {
  createCache(storeWrapper: any): any {
    // @ts-ignore: our current Ember Data types don't cover this properly
    return new CIOJSONAPICache(storeWrapper);
  }
}
